import Card from "components/card/custom";
import React, { useState } from "react";
import { useDisclosure } from "@chakra-ui/hooks";
import {
  Modal,
  ModalBody,
  ModalOverlay,
  ModalHeader
} from "@chakra-ui/modal";
import CustomerRegistrationForm from "./CustomerRegistrationForm"
import { BsPlusCircle } from "react-icons/bs";
import {
  MdHighlightOff,
} from "react-icons/md";
import { getClientsSecond } from "api/graphQL_clients";


const CreateCustomerModal = ({
  fetchClients,
  roleData,
}: {
  fetchClients: () => void;
  roleData?: any;
})  => { 

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isCloseModal, setIsCloseModal] =  React.useState<boolean>(false);
    const [clients, setClients] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(500);
    
    const handleClose = () => {
        setIsCloseModal(true)
        setTimeout(() => {
        setIsCloseModal(false)
        onClose();
        }, 300);
    };

    const fetchClientsList = () => {
        const params = { page: page, per_page: pageSize, searchTexts: "" };
        getClientsSecond(params)
        .then((data) => {
            setClients(
            data?.[0]?.map((ele: any) => {
                return {
                name: ele.name,
                id: ele.client_id,
                };
            })
            );
        });
    };

    return (
        <>
            <Card 
                extra="w-fit px-5 cursor-pointer"
                onClick={() => {
                    fetchClientsList();
                    onOpen();
                }}
            >
                <button className="flex items-center justify-center gap-2 whitespace-nowrap p-5 text-navy-700 outline-none dark:text-gray-200">
                    <BsPlusCircle className="h-5 w-5 text-brand-500" />
                    <span className="text-brand-500"> Add New Customer </span>
                </button>
            </Card>
            <Modal isOpen={isOpen} onClose={() => {}}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[900px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${isOpen && !isCloseModal ? "card-enter" : "card-exit"}`}> 
                    <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                        <MdHighlightOff className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white" onClick={handleClose}/>
                        Add New Customer
                    </ModalHeader>
                    <ModalBody className="p-2">
                        <CustomerRegistrationForm 
                            onClose = {onClose}
                            clients= { clients}
                            fetchClients = {fetchClients}
                        />
                    </ModalBody>
                    
                </Card>
            </Modal>
        </>
    )
}

export default CreateCustomerModal;
